import { useEffect, useRef } from "react";

const SCRIPT_LOAD_STATUS = "schaefflerLoadStatus";

function findScript(url: string) {
  const absoluteUrl = new URL(url, document.baseURI).href;
  return Array.from(document.scripts).find((script) => script.src === absoluteUrl);
}

export const useScript = (url: string, onLoad?: () => void) => {
  const onLoadRef = useRef(onLoad);
  onLoadRef.current = onLoad;

  useEffect(() => {
    if (!url) {
      return;
    }

    let script = findScript(url);
    const isNewScript = !script;

    if (!script) {
      script = document.createElement("script");
      script.src = url;
      script.async = true;
      script.dataset[SCRIPT_LOAD_STATUS] = "loading";
    }

    const handleLoad = () => {
      script.dataset[SCRIPT_LOAD_STATUS] = "loaded";
      onLoadRef.current?.();
    };

    if (script.dataset[SCRIPT_LOAD_STATUS] === "loaded") {
      onLoadRef.current?.();
    } else {
      script.addEventListener("load", handleLoad);
    }

    if (isNewScript) {
      document.body.appendChild(script);
    }

    // Custom-element libraries register against the document-global registry. Keep the script in
    // place across React remounts so another consumer cannot execute that registration a second time.
    return () => {
      script.removeEventListener("load", handleLoad);
    };
  }, [url]);
};
